import { cloneElement } from "react";

import PropTypes from "prop-types";

import useIsStuckVertically from "../utils/useIsStuckVertically";
import usePresentModeContext from "../utils/usePresentModeContext";
import { rootCss } from "./StickyBar.style";

const propTypes = {
  children: PropTypes.node,
};

const StickyBar = ({ children }) => {
  const { isVideoPresentModeActive } = usePresentModeContext();
  const { ref, isStuck } = useIsStuckVertically();

  return (
    <div css={rootCss(isVideoPresentModeActive)} ref={ref}>
      {cloneElement(children, { isStuck })}
    </div>
  );
};

StickyBar.propTypes = propTypes;
export default StickyBar;
